import isEmpty from 'lodash/isEmpty';
import { getEngineeringWorkReactiveScopeData } from 'pages/WellGuardian/WIR/utils';
import {
  WIRCreateJourneyStepsKeys,
  WIREngineeringWorkSections,
  WIRStageGate3Sections,
} from 'pages/WellGuardian/WIR/wir.constants';
import { useCallback, useMemo } from 'react';
import { useCountryState, useSelectedWIR } from 'redux/WellGuardian/selectors';
import wellGuardianApiClient from 'services/networking/wellGuardianApiClient';
import { WIR, WIRPhaseTypes } from 'types/wellGuardian';

import { getEngineeringWorkPhaseName } from '../utils/getSectionData';

export const useSectionEquipmentIdentificationData = () => {
  const wirFromState = useSelectedWIR();
  const countryState = useCountryState();

  const equipmentIdentificationPayload = useMemo(() => {
    const { phase, equipmentIdentification } = getEngineeringWorkReactiveScopeData(
      wirFromState,
      countryState,
    );
    const comments = equipmentIdentification?.comments;
    const resources = equipmentIdentification?.resources ?? [];

    const isTicked = !isEmpty(resources);

    return {
      isTicked,
      comments,
      resources,
      lastUpdatedDate: new Date().toISOString(),
      sectionCompleteConfirmation: equipmentIdentification?.sectionCompleteConfirmation,
      assignedTo: equipmentIdentification?.assignedTo || '',
      phase,
    };
  }, [wirFromState, countryState]);

  const saveEquipmentIdentificationSection = useCallback(
    async (section: string, processSaveResponse: (wirResponse: WIR | null) => void) => {
      if (
        wirFromState?.wirNumber &&
        (section === WIREngineeringWorkSections.equipmentIdentification ||
          section === WIRStageGate3Sections.equipmentIdentification)
      ) {
        processSaveResponse(
          await wellGuardianApiClient.updateWIREquipmentIdentification(
            wirFromState?.wirNumber,
            equipmentIdentificationPayload,
            equipmentIdentificationPayload.phase === WIRCreateJourneyStepsKeys.REACTIVE_SCOPE
              ? WIRPhaseTypes.REACTIVE_SCOPE
              : getEngineeringWorkPhaseName(countryState),
            countryState,
          ),
        );
      }
    },
    [wirFromState, equipmentIdentificationPayload, countryState],
  );

  return {
    saveEquipmentIdentificationSection,
    equipmentIdentificationPayload,
  };
};
